exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Cw7ujai680QpUm1Arb2ng {\n  overflow-y: auto;\n}\n\n._340k0kxpyYkuWw9djUXGKF {\n  padding: 10px 8px;\n}\n\n._1-JI9Gxta9IYZhXPFT-4M8 {\n  margin-top: 0;\n}\n\n.xjtjEeT2ahFQd3IDkbvcc {\n  font-size: 0.7em;\n}\n\n.ihnbltjrmjhdmWTi6X__I code {\n  white-space: inherit;\n}\n", ""]);

// exports
exports.locals = {
	"container": "Cw7ujai680QpUm1Arb2ng",
	"headerContainer": "_340k0kxpyYkuWw9djUXGKF",
	"title": "_1-JI9Gxta9IYZhXPFT-4M8",
	"source": "xjtjEeT2ahFQd3IDkbvcc",
	"preJsonView": "ihnbltjrmjhdmWTi6X__I"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true}!./src/widgets/Container/styles.css
// module id = 11
// module chunks = 0 1 2